import { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const FORM_SECTION_CARD_SX: SxProps<Theme> = {
  backgroundColor: {
    xs: 'transparent',
    sm: Color.white,
  },
  borderRadius: {
    xs: 0,
    sm: '8px',
  },
  boxShadow: {
    xs: 'none',
    sm: '0px 1px 4px rgba(0, 0, 0, 0.1)',
  },
  padding: {
    xs: 0,
    sm: '24px',
  },
  marginBottom: {
    xs: '20px',
    sm: '16px',
  },
};

export const FORM_SECTION_TITLE_SX: SxProps<Theme> = {
  fontSize: '1.25rem',
  fontWeight: 600,
  marginBottom: '8px',
  color: 'text.primary',
};

export const FORM_SECTION_DESCRIPTION_SX: SxProps<Theme> = {
  color: Color.iconGray,
  fontWeight: 400,
  fontSize: '0.875rem',
  marginBottom: '16px',
};
